export class LetterV2 {
    
    public id: string = "0";
    public name: string;
    public subject: string;
    public type: string;
    public text: string;
    public context_id: string = "";
    public event_id: string;
    public event_name: string;
    public isCongress: boolean;
    public isTemplate: boolean;
    public imageTop: string;
    public imageBottom: string;
    public imageBody: string;

    constructor() {}
}
